import React from 'react';
import { Popover, Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { pdf } from "@react-pdf/renderer";
import DownloadPdf from './DownloadPdf';
import InwardOutward_Report from './InwardOutward_Report/InwardOutward_Report';
import ResponseMessage from '../../Comman/Notification/ResponseMessge';

const DownloadCsv = ({ reportData, startDate, endDate, flag }) => {
    console.log(flag);
    console.log("reportData",reportData);

    const handleExportCSV = () => {
        if (!reportData || reportData.length === 0) {
            ResponseMessage.warning("No Data to Export");
            return;
        }
    
        // Define new header order and mapping
        const headerMap = {
            "SNo": "SI. No",
            "item_no": "Item No",
            "kanban_no": "Kanban No",
            "po_no": "PO No",
            "line_no": "Line No",
            "dispatch_area": "Dispatch Area",
            "eol_id": "EOL No",
            "bin_id": "Bin ID",
            "size_name": "Size and Qty",
            "quantity": "Total Quantity",
            "color": "Color",
            "added_by": "Added By",
            "added_on": "Added On"
        };
    
        // Define new header order
        const headers = Object.keys(headerMap);
        const csvHeaders = headers.map(key => `"${headerMap[key]}"`).join(',');
    
        // Convert data
        const csvRows = reportData.map(item => {
            return headers.map(header => {
                let value = item[header] || '';
    
                // Format size_name as "L: 40, M: 12"
                if (header === "size_name") {
                    try {
                        const sizeObj = JSON.parse(value);
                        value = Object.entries(sizeObj).map(([key, val]) => `${key}: ${val}`).join(', ');
                    } catch (e) {
                        value = value.toString();
                    }
                }
    
                // Escape quotes and wrap value in quotes
                return `"${value.toString().replace(/"/g, '""')}"`;
            }).join(',');
        });
    
        // Combine headers and rows
        const csv = [csvHeaders, ...csvRows].join('\n');
    
        // Create and trigger download
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `report_csv_${startDate}_to_${endDate}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        ResponseMessage.success("CSV Downloaded Sucessfully");
    };

    const handleExportCSVInward_outward =()=>{
        if (!reportData || reportData.length === 0) {
            ResponseMessage.warning("No Data to Export");
            return;
        }
    
        // Define new header order and mapping
        const headerMap = {
            "si_no": "SI. No",
            "batch_id": "Batch ID",
            "bin_id": "Bin ID",
            "bm_id": "BM ID",
            "bin_to": "Bin To",
            "bin_from": "Bin From",
            "movement_status": "Movement Status",
            "added_by": "Added By",
            "added_on": "Added On",
            "received_by": "Received By",
            "received_on": "Received On",
        };
    
        // Define new header order
        const headers = Object.keys(headerMap);
        const csvHeaders = headers.map(key => `"${headerMap[key]}"`).join(',');
    
        // Convert data
        const csvRows = reportData.map(item => {
            return headers.map(header => {
                let value = item[header] || '';
    
                // Format size_name as "L: 40, M: 12"
                if (header === "size_name") {
                    try {
                        const sizeObj = JSON.parse(value);
                        value = Object.entries(sizeObj).map(([key, val]) => `${key}: ${val}`).join(', ');
                    } catch (e) {
                        value = value.toString();
                    }
                }
    
                // Escape quotes and wrap value in quotes
                return `"${value.toString().replace(/"/g, '""')}"`;
            }).join(',');
        });
    
        // Combine headers and rows
        const csv = [csvHeaders, ...csvRows].join('\n');
    
        // Create and trigger download
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `report_csv_${startDate}_to_${endDate}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        ResponseMessage.success("CSV Downloaded Sucessfully");
    };
    

    const handleExportPDF = async () => {
        if (!reportData || Object.keys(reportData).length === 0) {
            ResponseMessage.warning("No data to export");
            return;
        }

        try {
            const blob = await pdf(<DownloadPdf reportData={reportData} startDate={startDate} endDate={endDate} />).toBlob();
            // Optional: Trigger file download
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `report_${startDate}_to_${endDate}.pdf`;
            link.click();
            // message.success("PDF downloaded successfully");
            ResponseMessage.success({ message: 'PDF Downloaded Sucessfully' })
        } catch (error) {
            console.error("PDF Generation Error: ", error); // Log the error for debugging
            ResponseMessage.success("Failed to generate PDF");
        }
    };

    const handleExportPDFInward_outward = async () => {
        console.log("clicked ");
        if (!reportData || Object.keys(reportData).length === 0) {
            ResponseMessage.warning("No data to export");
            return;
        }

        try {
            const blob = await pdf(<InwardOutward_Report reportData={reportData}
                startDate={startDate}
                endDate={endDate} />).toBlob();
            // Optional: Trigger file download
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `report_${startDate}_to_${endDate}.pdf`;
            link.click();
            ResponseMessage.success({ message: 'PDF Downloaded Sucessfully' })
        } catch (error) {
            console.error("PDF Generation Error: ", error); // Log the error for debugging
            ResponseMessage.success("Failed to generate PDF");
        }

    };

    const handleClick = () => {
        if (flag) {
            handleExportPDFInward_outward();
        } else {
            handleExportPDF();
        }
    };

    const handleCSVClick = () => {
        if (flag) {
            handleExportCSVInward_outward();
        } else {
            handleExportCSV();
        }
    };

    const content = (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Button type="text" onClick={handleCSVClick}>
                <strong>Export CSV</strong>
            </Button>
            <Button type="text" onClick={handleClick}>
                <strong>Export PDF</strong>
            </Button>
        </div>
    );

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span></span>
            <Popover
                placement="topRight"
                content={content}
                trigger="click"
                arrow={false}
            >
                <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                >
                    Export
                </Button>
            </Popover>
        </div>
    );
};

export default DownloadCsv;
